export const playAudioFile = (file) => {
    if (!file) return;
    try {
        file.play();
    } catch (e) {
        // Ignore error: IOS devices won't allow us to auto play sounds
    }
};
